import React from 'react';
import { DynamicType, IBackgroundLayerProps, ILayerProps } from '@meitu/saas-editor-core/es/version-types';
import CssDynamic from './css-dynamic';

const style = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    overflow: 'hidden',
    pointerEvents: 'none',
} as React.CSSProperties;
const DynamicBgLayerContent: React.FC<{
    width: number;
    height: number;
    backgroundLayer: ILayerProps | null;
}> = ({ width, height, backgroundLayer }) => {
    if (!backgroundLayer || !backgroundLayer.data) {
        return null;
    }
    const { dynamicInfo } = backgroundLayer.data as IBackgroundLayerProps;

    return (
        <div className="c-dynamic-bg-layer" style={style}>
            {dynamicInfo && dynamicInfo.dynamicType === DynamicType.CSS && !dynamicInfo.hidden ? (
                <CssDynamic name={dynamicInfo.name} />
            ) : null}
        </div>
    );
};

export default DynamicBgLayerContent;
